export default __webpack_public_path__ + "static/media/carousel_2.adb1b51b.svg";